export const PURIFY_APP_LOADER = {
  desktop: ``,
  mobile: ``
};
